module.exports = __webpack_public_path__ + "img/hand.2e681eb0.svg";